import {
    GET_ALLPAYMENTGY_LOADING,
    GET_ALLPAYMENTGY_SUCCESS,
    GET_ALLPAYMENTGY_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    merchants: null,
  };
  
  export const getAllPaymentGyListReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any }
  ) => {
    switch (action.type) {
      case GET_ALLPAYMENTGY_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_ALLPAYMENTGY_SUCCESS:
        return {
          ...state,
          loading: false,
          merchants: action.payload,
          error: null,
        };
      case GET_ALLPAYMENTGY_FAILED:
        return {
          ...state,
          loading: false,
          merchants: null,
          error: action.error,
        };
       
      default:
        return state;
    }
  };
  